import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import logo from "../../assets/images/le-logo.png";

const ResetPassword = ({ match }) => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");
  const [isValid, setIsValid] = useState(false);
  const navigate = useNavigate();
  const API_URI = process.env.REACT_APP_BASE_URL;

  // const { token } = match.params; // Token from the URL
  const { token } = useParams();

  useEffect(() => {
    // Verify the token on component mount
    const verifyToken = async () => {
      try {
        const response = await fetch(`${API_URI}forgot-password.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Set content type to JSON
          },
          body: JSON.stringify({
            token: token,
            type: "checktoken",
          }),
        });
        const data = await response.json();
        if (data.success) {
          setIsValid(true);
        } else {
          setError(data.message);
        }
      } catch (err) {
        setError("Something went wrong");
      }
    };

    verifyToken();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");

    if (!password || password !== confirmPassword) {
      setError("Passwords must match");
      return;
    }

    try {
      const response = await fetch("/api/reset-password.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ token, password }),
      });

      const data = await response.json();

      if (data.success) {
        setMessage("Password successfully reset");
        setTimeout(() => {
          navigate("/login"); // Redirect to login page after success
        }, 2000);
      } else {
        setError(data.message);
      }
    } catch (err) {
      setError("Something went wrong. Please try again later.");
    }
  };

  return (
    <div className="content" style={{ backgroundColor: "#f8fafb" }}>
      <div className="container" style={{ height: "100vh" }}>
        <div className="row justify-content-center p-4">
          <div className="col-md-6">
            <div className="card shadow-sm">
              <div className="card-body">
                <div className="text-center mb-4">
                  <img
                    src={logo}
                    alt="logo"
                    className="img-fluid"
                    style={{ maxHeight: "60px" }}
                  />
                </div>
                <h3 className="text-center mb-4">Reset Password</h3>
                {isValid ? (
                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="password">New Password:</label>
                      <input
                        type="password"
                        id="password"
                        style={{
                          width: "100%",
                          padding: "8px",
                          marginBottom: "15px",
                          borderRadius: "4px",
                          border: "1px solid #ced4da",
                          fontSize: "14px",
                        }}
                        placeholder="Enter new password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                      <label htmlFor="confirmPassword">
                        Confirm New Password:
                      </label>
                      <input
                        type="password"
                        id="confirmPassword"
                        style={{
                          width: "100%",
                          padding: "8px",
                          marginBottom: "15px",
                          borderRadius: "4px",
                          border: "1px solid #ced4da",
                          fontSize: "14px",
                        }}
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                      />
                      <button
                        type="submit"
                        className="btn btn-primary btn-block mt-3"
                        style={{ fontSize: "14px" }}
                      >
                        Reset Password
                      </button>
                    </div>
                    <div className="form-group"></div>
                  </form>
                ) : null}
                {/* {message && (
                  <div className="alert alert-success mt-3">{message}</div>
                )} */}
                {error && (
                  <div className="alert alert-danger mt-3">{error}</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
